import React, { useEffect } from "react";
import ManualContent from "./manual";
import numeral from "numeral";
import ReconciliationHeader from "./reconciliationHeader";
import { FormattedMessage, useIntl } from "react-intl";
import ChoiceDeadlineToSplit from "./choiceDeadlineToSplit";
import { notification } from "antd";
import LoaderSimple from "../../../general/loader";
import { useSelector } from "react-redux";

const ReconciliationForm = props => {
  const {
    totalAmount,
    amountToPay,
    residueAmount,
    deadlineDescription,
    deadlinesDetail,
    setPaymentValueResidue,
    paymentValueResidue,
    setCheckbox,
    checkbox,
    setDateValueResidue,
    dateValueResidue,
    setValueRadio,
    valueRadio,
    isMultipleReconciliation,
    movementAmount,
    style,
    selectedMovementDetails,
    reconcilableDeadlines,
    openDeadlineDetail,
    setInvalidSelectionBiggerDeadlines,
    invalidSelectionBiggerDeadlines,
    deadlinesToReconcile,
    difference,
    setDeadlineToSplit,
    isSplittingDeadlines,
    defaultValueToSplit,
    setDefaultValueToSplit
  } = props;

  const isGettingReconcilableDeadlines = useSelector(state => state.reconciliation.isGettingReconcilableDeadlines);

  useEffect(() => {
    const absAmount = Math.abs(residueAmount);

    // salvo in un array tutti gli amount delle deadlines selezionate e riconciliabili
    const deadlinesAmounts = deadlinesToReconcile?.map(i =>
      parseFloat(i.totalAmount));

    let inferiorAmounts = [];
    // cerco tra gli amount delle deadlines selezionate se ve n'è qualcuno inferiore o uguale al residuo e li salvo in un array
    if (!isGettingReconcilableDeadlines) {
      if (deadlinesAmounts) {
        deadlinesAmounts.forEach(am => {
          if (Math.abs(am) <= absAmount) {
            inferiorAmounts.push(am);
          }
        });
      }
    }

    // se l'array risulta popolato da almeno un amount, vuol dire che il residuo non potrà essere frazionato tra le scadenze selezionate
    setInvalidSelectionBiggerDeadlines(inferiorAmounts?.length > 0 && difference < 0 ? true : false);
  }, [reconcilableDeadlines, residueAmount]);

  useEffect(() => {
    if (invalidSelectionBiggerDeadlines) {
      openInvalidDeadlinesNotification();
    }
  }, [invalidSelectionBiggerDeadlines]);

  const invalidSelectionDeadlines = useIntl().formatMessage({
    id: "deadlines.reconciliation.invalidSelectionDeadlines"
  });

  const invalidSelectionDeadlinesDescription = useIntl().formatMessage({
    id: "deadlines.reconciliation.invalidSelectionDeadlinesDescription"
  });

  const openInvalidDeadlinesNotification = () => {
    notification["error"]({
      message: invalidSelectionDeadlines,
      description: invalidSelectionDeadlinesDescription,
      className: "error-deadline-selection"
    });
  };

  return (
    <div style={style ? style : { padding: "24px" }}>
      <ReconciliationHeader
        totalAmount={totalAmount}
        amountToPay={amountToPay}
        residueAmount={residueAmount}
        setValueRadio={setValueRadio}
        valueRadio={valueRadio}
        isMultipleReconciliation={isMultipleReconciliation}
        isModalMovementsBigger={false}
        movementAmount={movementAmount}
        selectedMovementDetails={selectedMovementDetails}
      />
      {valueRadio === "1" && !isSplittingDeadlines ? (
        <div style={{ width: "100%" }}>
          <div className="dbx-reconciliation-form-deadlines-title">
            <b>Crea nuova scadenza dal residuo</b>
          </div>
          <div className="dbx-reconciliation-form-deadlines-description">
            Stai creando una nuova scadenza per il saldo residuo di:{" "}
            {deadlineDescription}.
          </div>
          {deadlinesToReconcile?.length > 1 && (
            <>
              <div className="dbx-reconciliation-form-deadlines-choice-title">
                <FormattedMessage id="deadlines.reconciliation.choice" />
              </div>
              <div className="dbx-reconciliation-form-deadlines-choice-container">
                {
                  <ChoiceDeadlineToSplit
                    deadlinesToReconcile={deadlinesToReconcile}
                    openDeadlineDetail={openDeadlineDetail}
                    setDeadlineToSplit={setDeadlineToSplit}
                    defaultValueToSplit={defaultValueToSplit}
                    setDefaultValueToSplit={setDefaultValueToSplit}
                  />
                }
              </div>
            </>
          )}
          <ManualContent
            deadlinesDetail={deadlinesDetail}
            paymentValue={paymentValueResidue}
            setPaymentValue={setPaymentValueResidue}
            initialValue={residueAmount}
            editedValue={residueAmount}
            isResidueDeadline={true}
            checkbox={checkbox}
            setCheckbox={setCheckbox}
            setDateValueResidue={setDateValueResidue}
            dateValueResidue={dateValueResidue}
            isDrawer={isMultipleReconciliation ? false : true}
            isMultipleReconciliation={isMultipleReconciliation}
            movementAmount={movementAmount}
          />
        </div>
      ) : valueRadio === "2" && !isSplittingDeadlines ? (
        <div className="dbx-reconciliation-form-rebate">
          <div
            style={{
              fontSize: "18px",
              marginTop: !isMultipleReconciliation && "50px"
            }}
          >
            <b>Abbuona</b>
          </div>
          <div style={{ marginBottom: "50px" }}>
            Stai saldando {deadlineDescription} con un abbuono di{" "}
            <b>
              {!isMultipleReconciliation
                ? numeral(residueAmount).format("0,0.00")
                : numeral(Math.abs(residueAmount)).format("0,0.00")}
              {" €"}
            </b>
            . ({" "}
            {!isMultipleReconciliation
              ? numeral(Math.abs(amountToPay)).format("0,0.00")
              : numeral(Math.abs(movementAmount)).format("0,0.00")}
            {" €"} al posto di {numeral(Math.abs(totalAmount)).format("0,0.00")}
            {" €"}).
          </div>
          <div className="dbx-reconciliation-form-deadlines-choice-title">
            <FormattedMessage id="deadlines.reconciliation.choiceRebate" />
          </div>
          <ChoiceDeadlineToSplit
            deadlinesToReconcile={deadlinesToReconcile}
            openDeadlineDetail={openDeadlineDetail}
            setDeadlineToSplit={setDeadlineToSplit}
            defaultValueToSplit={defaultValueToSplit}
            setDefaultValueToSplit={setDefaultValueToSplit}
          />
        </div>
      ) : (
        <div
          style={{
            width: "1090px",
            height: "442px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <LoaderSimple />
        </div>
      )}
    </div>
  );
};

export default ReconciliationForm;
